<div class="modal-header">
  <h5 class="modal-title fw-bold">Download Attendance Report</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="mb-3">
      <label for="startDate" class="form-label">Start Date</label>
      <input
        type="date"
        id="startDate"
        class="form-control"
        formControlName="startDate"
        [class.is-invalid]="form.get('startDate')?.invalid && form.get('startDate')?.touched" />
      <div class="invalid-feedback">Start Date is required.</div>
    </div>
    <div class="mb-3">
      <label for="endDate" class="form-label">End Date</label>
      <input
        type="date"
        id="endDate"
        class="form-control"
        formControlName="endDate"
        [class.is-invalid]="form.get('endDate')?.invalid && form.get('endDate')?.touched" />
      <div class="invalid-feedback">End Date is required.</div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="form.invalid || isLoading">
    <ng-container *ngIf="isLoading; else defaultText">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Downloading...
    </ng-container>
    <ng-template #defaultText>Download</ng-template>
  </button>
</div>
